import { FC, useContext } from 'react'
import './TimelineSelection.scss'
import { PositionRange } from '../../types'
import { useVisiblePositionPercent } from '../hooks/useVisiblePositionPercent'
import { TimelineSelectionHandle } from './TimelineSelectionHandle'
import { CutterContext } from '../contexts/CutterContext'
import { InternalContext } from '../contexts/InternalContext'
import { TimelineSelectionBody } from './TimelineSelectionBody'

interface Props {
  internalSelection: PositionRange
}

export const TimelineSelection: FC<Props> = ({ internalSelection }) => {
  const { setSelection } = useContext(CutterContext)
  const { setInternalSelection } = useContext(InternalContext)

  const left = useVisiblePositionPercent(internalSelection[0])
  const width = useVisiblePositionPercent(internalSelection[1]) - left

  const setPosition = () => setSelection(internalSelection)

  return (
    <div className="TimelineSelection" style={{ left: `${left + width / 2}%`, minWidth: `${width}%` }}>
      <TimelineSelectionBody range={internalSelection} />

      <TimelineSelectionHandle
        internalPosition={internalSelection[0]}
        setInternalPosition={(position) => setInternalSelection([position, internalSelection[1]])}
        setPosition={setPosition}
      />

      <TimelineSelectionHandle
        internalPosition={internalSelection[1]}
        setInternalPosition={(position) => setInternalSelection([internalSelection[0], position])}
        setPosition={setPosition}
      />
    </div>
  )
}
